import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IconButton, RefreshIndicator, IconMenu, MenuItem, Dialog, FlatButton} from 'material-ui';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import List from 'material-ui/svg-icons/action/list'
import Map from 'material-ui/svg-icons/maps/map'
import Settings from 'material-ui/svg-icons/action/settings';
import Mapbox, {MapStyle} from '../../openexplore/Mapbox/Mapbox';
import styles from './Reports.css';
import {fetchApp} from "../../../store/apps/actions";
import SearchBox from '../../common/SearchBox/SearchBox';
import {Link} from "react-router-dom";
import Loading from "../../common/Loading/Loading";
import {search, setMapStyle, setOxListMode} from "../../../store/ui/actions";
import withTranslation from "../../../hoc/withTranslation";
import {
    REPORTS_LIST_PAGE,
    REPORTS_MAP_PAGE, REPORT_PAGE
} from "../../../constants/routes";
import {deleteReport, getReports, resetReport} from "../../../store/reports/action";
import ReportList from "../Report/ReportList";

export const DisplayMode = {
    MODE_LIST: 'mode_list',
    MODE_MAP: 'mode_map'
};

export class Reports extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        app: null
    };

    state = {
        floatingPopoverOpened: false,
        floatingAnchorElement: null,
        openRemoveReport: false,
        reportToRemove: null,
        listMode: this.props.listMode
    };

    componentWillMount() {
        //this.update(this.props);
        this.props.resetReport();
        this.fetchApplication();

        if (this.props.app && this.props.currentLang) {
            this.props.getReports(this.props.app, this.props.currentLang);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }

        if (this.props.sending && !nextProps.sending) {
            this.handleCloseReport()
        }

        if (this.props.app !== nextProps.app && nextProps.app && nextProps.currentLang) {
            this.props.getReports(nextProps.app, nextProps.currentLang);
        }
        this.setState({
            listMode: nextProps.listMode
        });
    }
/*
    componentWillUpdate(nextProps) {
        if (nextProps !== this.props) {
            this.update(nextProps)
        }
    }

    update(props) {
    }
*/
    // Logic

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    filteredReports() {
        const {searchValue} = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.reports;
        }

        return this.props.reports.filter((report) => {
            const includesName = report.title && report.title.includes(searchValue);
            const includesDesc = report.description && report.description.includes(searchValue);

            return includesName || includesDesc;
        });
    }

    // Handlers


    onReportClicked = (report) => {
        let url = REPORT_PAGE.replace(':appId', this.props.app.id).replace(':reportId', report.id);
        this.props.history.push(url);
    };
    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    onMapStyleChanged = (style) => {
        this.props.setMapStyle(style);
    };

    // Delete point

    handleCloseReport = () => {
        this.setState({
            openRemoveReport: false,
            reportToRemove: null
        });
    };

    deleteReport = () => {
        this.props.deleteReport(this.props.app.id, this.state.reportToRemove.id, this.props.currentLang);
    };

    // Floating Button

    handleOpenFloatingButton = (event) => {
        event.preventDefault();

        this.setState({
            floatingPopoverOpened: true,
            floatingAnchorElement: event.currentTarget
        });
    };

    handleCloseFloatingButton = () => {
        this.setState({
            floatingPopoverOpened: false,
            floatingAnchorElement: null
        });
    };


    // Render

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        if (this.props.mode === DisplayMode.MODE_MAP) {
            style = {
                ...style,
                ...styles.toolBar.containerMap
            }
        } else {
            style = {
                ...style,
                ...styles.toolBar.containerList
            }
        }

        return style;
    }

    renderToolbar() {
        return (
            <Toolbar style={this.toolbarContainerStyle()}>
                <ToolbarGroup firstChild={true} style={styles.toolBar.searchBar}>
                    <SearchBox
                        onChange={this.onSearchChanged}
                        value={this.props.searchValue}
                    />
                </ToolbarGroup>
                <ToolbarGroup>
                    {this.props.mode === DisplayMode.MODE_MAP &&
                    <Link to={REPORTS_LIST_PAGE.replace(':appId', this.props.app.id)}>
                        <IconButton
                            onClick={this.onListTriggered}
                            tooltip={this.props.t('module.open_explore.list_mode')}
                            tooltipPosition='bottom-center'
                        >
                            <List/>
                        </IconButton>
                    </Link>
                    }
                    {this.props.mode === DisplayMode.MODE_MAP &&
                    <IconMenu
                        iconButtonElement={
                            <IconButton
                                tooltip={this.props.t('module.open_explore.map_style_tooltip')}
                                tooltipPosition='bottom-center'
                            >
                                <Settings />
                            </IconButton>
                        }
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    >
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.streets')}
                            onClick={() => this.onMapStyleChanged(MapStyle.STREETS) }
                            checked={this.props.mapStyle === MapStyle.STREETS}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.satellite')}
                            onClick={() => this.onMapStyleChanged(MapStyle.SATELLITE) }
                            checked={this.props.mapStyle === MapStyle.SATELLITE}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.outdoors')}
                            onClick={() => this.onMapStyleChanged(MapStyle.OUTDOORS) }
                            checked={this.props.mapStyle === MapStyle.OUTDOORS}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.light')}
                            onClick={() => this.onMapStyleChanged(MapStyle.LIGHT) }
                            checked={this.props.mapStyle === MapStyle.LIGHT}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.dark')}
                            onClick={() => this.onMapStyleChanged(MapStyle.DARK) }
                            checked={this.props.mapStyle === MapStyle.DARK}
                        />
                    </IconMenu>
                    }
                    {this.props.mode === DisplayMode.MODE_LIST &&
                    <Link to={REPORTS_MAP_PAGE.replace(':appId', this.props.app.id)}>
                        <IconButton
                            tooltip={this.props.t('module.open_explore.map_mode')}
                            tooltipPosition='bottom-center'
                        >
                            <Map/>
                        </IconButton>
                    </Link>
                    }
                </ToolbarGroup>
            </Toolbar>
        );
    }

    renderMap(reports) {
        return (
            <span>
                <Mapbox
                    mapStyle={this.props.mapStyle}
                    style={styles.map}
                    reports={reports}
                    onReportClicked={this.onReportClicked}
                />
                <RefreshIndicator
                    size={50}
                    left={70}
                    top={0}
                    loadingColor="#FF9800"
                    status={this.props.loading ? 'loading' : 'hide'}
                    style={styles.loader}
                />
            </span>
        );
    }

    renderList(reports) {
        let bottomNavigationBarStyle = styles.list.bottomNavigationBar;
        bottomNavigationBarStyle.paddingLeft = this.props.navLeftPadding;

        return (
            <div>
                <div style={styles.list.container}>
                    <ReportList
                        app={this.props.app}
                        user={this.props.user}
                        reports={reports}
                        title={this.props.t('module.report.report_plural')}
                    />
                </div>
            </div>
        );
    }

    renderDeleteReportDialog(report) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseReport}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteReport}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveReport}
                    onRequestClose={this.handleClosePoint}>
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html: this.props.t('module.open_explore.remove_point_confirmation', {
                            name: report.name
                        })
                    }}/>
                </p>
                }
            </Dialog>
        );
    }

    render() {
        // No app loading anyway
        if (!this.props.app) {
            return <Loading paper={false} />
        }

        // In list mode, show loader
        if (this.props.mode === DisplayMode.MODE_LIST && this.props.loading) {
            return <Loading paper={false} />
        }

        const reports = this.filteredReports() || [];

        return (
            <div style={styles.container}>
                {this.state.reportToRemove && this.renderDeleteReportDialog(this.state.reportToRemove)}

                {this.props.mode === DisplayMode.MODE_MAP && this.renderMap(reports)}
                {this.props.mode === DisplayMode.MODE_LIST && this.renderList(reports)}

                {this.renderToolbar()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        sending: state.reports.sending,
        loading: state.reports.pending,
        reports: state.reports.content,
        user: state.auth.content,
        currentLang: state.ui.currentLang,
        navLeftPadding: state.ui.leftPadding,
        searchValue: state.ui.search,
        mapStyle: state.ui.mapStyle,
        listMode: state.ui.oxListMode
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    if (!ownProps.mode) {
        props.mode = state.ui.oxMode
    }

    if (!ownProps.listMode) {
        props.listMode = state.ui.oxListMode
    }

    return props;
}

export default connect(mapStateToProps, {
    getReports,
    fetchApp,
    search,
    setMapStyle,
    deleteReport,
    resetReport,
    setOxListMode
})(withRouter(withTranslation(Reports)));



// WEBPACK FOOTER //
// src/components/report/Reports/Reports.js